/**
 * Languages.
 * @module constants/Languages
 */

module.exports = {
  af: 'Afrikaans',
  ar: 'العربية',
  bg: 'Български',
  bn: 'বাংলা',
  ca: 'Català',
  cs: 'Čeština',
  cy: 'Cymraeg',
  da: 'Dansk',
  de: 'Deutsch',
  el: 'Ελληνικά',
  en: 'English',
  eo: 'Esperanto',
  es: 'Español',
  et: 'Eesti',
  eu: 'Euskara',
  fa: 'فارسی',
  fi: 'Suomi',
  fr: 'Français',
  fu: 'Furlan',
  ga: 'Gaeilge',
  gl: 'Galego',
  he: 'עברית',
  hi: 'हिन्दी',
  hr: 'Hrvatski',
  hu: 'Magyar',
  hy: 'Հայերեն',
  id: 'Bahasa Indonesia',
  it: 'Italiano',
  ja: '日本語',
  ka: 'ქართული',
  kn: 'ಕನ್ನಡ',
  ko: '한국어',
  lt: 'Lietuvių',
  lv: 'Latviešu',
  mi: 'Te Reo Māori',
  mk_MK: 'Македонски',
  ms: 'Bahasa Melayu',
  mt: 'Malti',
  my: 'မြန်မာ',
  nl: 'Nederlands',
  nn: 'Nynorsk',
  no: 'Norsk',
  pl: 'Polski',
  pt: 'Português',
  pt_BR: 'Português (Brasil)',
  rm: 'Rumantsch',
  ro: 'Română',
  ru: 'Русский',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  sm: 'Gagana Samoa',
  sq: 'Shqip',
  sr: 'Српски',
  sr_Cyrl: 'Српски (ћирилица)',
  sr_Latn: 'Srpski (latinica)',
  sv: 'Svenska',
  sw: 'Kiswahili',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  th: 'ไทย',
  tl: 'Filipino',
  to: 'Lea Fakatonga',
  tr: 'Türkçe',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  zh: '中文',
  zh_CN: '中文 (简体)',
  zh_HK: '中文 (香港)',
  zh_TW: '中文 (繁體)',
};

// export default languages;
